module.exports = __webpack_public_path__ + "static/media/IMG_3504-min.c164b0e9.JPG";